import React, { Fragment, createRef } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { SITENAMEALIAS } from "../utils/init";
import { FetchUserSettings, GetTestUserToken, getAuthUuid, getAuthToken } from "../utils/service";
import { showToast } from "../utils/library";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.sidebarRef = createRef();
    this.sectionRefs = {};

    this.state = {
      currentMenu: this.props.location.pathname,
      accountStatusId: localStorage.getItem(
        SITENAMEALIAS + "_account_status_id"
      ),
      expandedSection: null,
      expandedSubSection: null,
      isVerified: false,
      enableMerchantReferral: 0,
      modeLoading: false,
      topMenus: [
        {
          title: "Get Started",
          permissionTitle: "Getting Started",
          path: "/get-started",
          icon: "mdi-briefcase-check",
          permissionLevel: 1,
          isRenderable: true,
        },
        {
          title: "Dashboard",
          permissionTitle: "Dashboard",
          path: "/dashboard",
          icon: "mdi-view-dashboard",
          permissionLevel: 2,
          isRenderable: false,
        },
      ],
      sections: [
        {
          id: "get-paid",
          title: "Get Paid",
          icon: "mdi-cash-multiple",
          items: [
            {
              title: "Create Payment",
              permissionTitle: "Create Payment",
              path: "/create-payment",
              icon: "mdi-plus-circle-outline",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Products",
              permissionTitle: "Products",
              path: "/product-catalog",
              icon: "mdi-package-variant-closed",
              permissionLevel: 2,
              isRenderable: false,
            },
          ],
        },
        {
          id: "transactions",
          title: "Transactions",
          icon: "mdi-swap-horizontal",
          isSingleLink: true,
          singlePath: "/transactions",
          permissionTitle: "Transactions",
          permissionLevel: 2,
          isRenderable: false,
          items: [],
        },
        {
          id: "settlement",
          title: "Settlement",
          icon: "mdi-bank-outline",
          items: [
            {
              title: "Settlement Wallets",
              permissionTitle: "Settlement Wallets",
              path: "/wallet",
              icon: "mdi-wallet-outline",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Add Crypto Address",
              permissionTitle: "Add Crypto Address",
              path: "/crypto-address",
              icon: "mdi-bitcoin",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Add Bank Account",
              permissionTitle: "Add Bank",
              path: "/bank-info",
              icon: "mdi-bank-plus",
              permissionLevel: 2,
              isRenderable: false,
            },
          ],
        },
        {
          id: "analytics",
          title: "Analytics",
          icon: "mdi-chart-bar",
          items: [
            {
              title: "Insights",
              permissionTitle: "Insights",
              path: "/insights",
              icon: "mdi-lightbulb-on-outline",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Reward Analytics",
              permissionTitle: "Reward Analytics",
              path: "/rewards/analytics",
              icon: "mdi-chart-donut",
              permissionLevel: 2,
              isRenderable: false,
            },
          ],
        },
        {
          id: "team",
          title: "Team",
          icon: "mdi-account-group-outline",
          items: [
            {
              title: "User Management",
              permissionTitle: "User Management",
              path: "/user-management",
              icon: "mdi-account-supervisor",
              permissionLevel: 2,
              isRenderable: false,
            },
          ],
        },
        {
          id: "configuration",
          title: "Configuration",
          icon: "mdi-settings",
          items: [
            {
              title: "Payment Setup",
              permissionTitle: "Payment Settings",
              path: "/payment-settings",
              icon: "mdi-credit-card-settings",
              permissionLevel: 2,
              isRenderable: false,
            },

            {
              title: "Checkout Templates",
              permissionTitle: "Checkout Templates",
              icon: "mdi-file-document-edit-outline",
              permissionLevel: 2,
              isRenderable: false,
              isSubSection: true,
              subSectionId: "checkout-templates",
              children: [
                {
                  title: "Payment Options",
                  permissionTitle: "Billing",
                  path: "/billing",
                  icon: "mdi-toggle-switch-outline",
                  permissionLevel: 2,
                  isRenderable: false,
                },
                {
                  title: "Fee Handling",
                  permissionTitle: "Fee Handling",
                  path: "/fees-handling",
                  icon: "mdi-percent",
                  permissionLevel: 2,
                  isRenderable: false,
                },
                {
                  title: "Buyer Info",
                  permissionTitle: "Buyer Fields",
                  path: "/buyer-information",
                  icon: "mdi-account-details",
                  permissionLevel: 2,
                  isRenderable: false,
                },
                {
                  title: "Shipping",
                  permissionTitle: "Shipping & Handling",
                  path: "/shipping-handling",
                  icon: "mdi-truck",
                  permissionLevel: 2,
                  isRenderable: false,
                },
                {
                  title: "Discounts",
                  permissionTitle: "Discounting",
                  path: "/discounting-profile",
                  icon: "mdi-tag-outline",
                  permissionLevel: 2,
                  isRenderable: false,
                },

                {
                  title: "Redirects",
                  permissionTitle: "Redirects",
                  path: "/redirects",
                  icon: "mdi-redo-variant",
                  permissionLevel: 2,
                  isRenderable: false,
                },
              ],
            },
            {
              title: "Rewards",
              permissionTitle: "Rewards",
              path: "/rewards",
              icon: "mdi-gift",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Limits",
              permissionTitle: "Limits",
              path: "/limits",
              icon: "mdi-speedometer",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Payment Tolerance",
              permissionTitle: "Payment Tolerance",
              path: "/payment-tolerance",
              icon: "mdi-alert-circle-outline",
              permissionLevel: 2,
              isRenderable: false,
            },
          ],
        },
        {
          id: "earn",
          title: "Earn",
          icon: "mdi-gift-outline",
          isSingleLink: true,
          singlePath: "/earn",
          permissionTitle: "Earn",
          permissionLevel: 2,
          isRenderable: false,
          items: [],
        },
        {
          id: "escrow",
          title: "Escrow",
          icon: "mdi-shield-check-outline",
          items: [
            {
              title: "Payer",
              permissionTitle: "Escrow Payer",
              path: "/escrow/payer/contracts",
              icon: "mdi-cash",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Payee",
              permissionTitle: "Escrow Payee",
              path: "/escrow/payee/contracts",
              icon: "mdi-account-arrow-right-outline",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Approver",
              permissionTitle: "Escrow Approver",
              path: "/escrow/approval/contracts",
              icon: "mdi-account-check-outline",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "View contracts",
              permissionTitle: "Escrow Funded Contracts",
              path: "/escrow/funded-contracts",
              icon: "mdi-coins",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "View disputes",
              permissionTitle: "Escrow Dispute",
              path: "/escrow/contract/dispute",
              icon: "mdi-gavel",
              permissionLevel: 2,
              isRenderable: false,
            },
          ],
        },
        {
          id: "developers",
          title: "Developers",
          icon: "mdi-code-tags",
          items: [
            {
              title: "API Keys",
              permissionTitle: "API Keys",
              path: "/api-key",
              icon: "mdi-key-variant",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "API",
              permissionTitle: "API",
              path: (() => {
                const brokerDomain = localStorage.getItem(
                  SITENAMEALIAS + "_brokerDomain"
                );
                return brokerDomain
                  ? `${brokerDomain}/api-doc/`
                  : "https://paybito.com/api-doc/";
              })(),
              icon: "mdi-book-open-page-variant",
              permissionLevel: 2,
              isRenderable: false,
              isExternal: true,
            },
            {
              title: "Domain Whitelisting",
              permissionTitle: "Domain Whitelisting",
              path: "/domain-whitelisting",
              icon: "mdi-shield-check-outline",
              permissionLevel: 2,
              isRenderable: false,
            },
            {
              title: "Webhooks",
              permissionTitle: "Webhooks",
              path: "/webhooks",
              icon: "mdi-webhook",
              permissionLevel: 2,
              isRenderable: false,
            },
          ],
        },
      ],
    };

    this.handleSelectCurrentMenu = this.handleSelectCurrentMenu.bind(this);
    this.toggleSection = this.toggleSection.bind(this);
    this.toggleSubSection = this.toggleSubSection.bind(this);
    this.lockTooltip =
      "Complete business verification to start accepting payments";
  }

  handleToggleMode = async () => {
    if (this.state.modeLoading) return;
    const { isTestMode } = this.props;

    if (!isTestMode) {
      // Check for basic verification before allowing switch to Test Mode
      const isVerified = localStorage.getItem(
        SITENAMEALIAS + "_basic_verification_submitted"
      );
      if (isVerified !== "1") {
        showToast("warning", "Please submit basic verification first");
        return;
      }

      this.setState({ modeLoading: true });
      // Switch to Test Mode
      try {
        const payload = {
          merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          uuid: getAuthUuid(),
        };
        const res = await GetTestUserToken(payload);
        if (res.data && res.data.status) {
          const { stageUuid, authTokenResponse } = res.data.data;
          const { accessToken } = authTokenResponse;

          localStorage.setItem(
            SITENAMEALIAS + "_test_access_token",
            accessToken
          );
          localStorage.setItem(SITENAMEALIAS + "_test_uuid", stageUuid);
          localStorage.setItem(SITENAMEALIAS + "_is_test_mode", "true");
          showToast("success", "Switched to Test Mode");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          showToast("error", "Failed to get test token");
          this.setState({ modeLoading: false });
        }
      } catch (err) {
        console.error("Error switching to test mode:", err);
        showToast("error", "Failed to switch to test mode");
        this.setState({ modeLoading: false });
      }
    } else {
      // Switch to Live Mode
      localStorage.setItem(SITENAMEALIAS + "_is_test_mode", "false");
      showToast("success", "Switched to Live Mode");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  toggleSection(sectionId) {
    this.setState(
      (prevState) => ({
        expandedSection:
          prevState.expandedSection === sectionId ? null : sectionId,
        expandedSubSection:
          prevState.expandedSection === sectionId
            ? null
            : prevState.expandedSubSection,
      }),
      () => {
        // Only scroll when opening, and only if the section bottom is clipped
        if (this.state.expandedSection === sectionId) {
          setTimeout(() => {
            const sectionEl = this.sectionRefs[sectionId];
            const sidebarEl = this.sidebarRef.current;
            if (sectionEl && sidebarEl) {
              const sidebarBottom = sidebarEl.getBoundingClientRect().bottom;
              const sectionBottom = sectionEl.getBoundingClientRect().bottom;
              if (sectionBottom > sidebarBottom) {
                sidebarEl.scrollBy({
                  top: sectionBottom - sidebarBottom + 16,
                  behavior: "smooth",
                });
              }
            }
          }, 280);
        }
      }
    );
  }

  toggleSubSection(subSectionId, e) {
    e.stopPropagation();
    this.setState(
      (prevState) => ({
        expandedSubSection:
          prevState.expandedSubSection === subSectionId ? null : subSectionId,
      }),
      () => {
        if (this.state.expandedSubSection === subSectionId) {
          setTimeout(() => {
            const sectionEl = this.sectionRefs["configuration"];
            const sidebarEl = this.sidebarRef.current;
            if (sectionEl && sidebarEl) {
              const sidebarBottom = sidebarEl.getBoundingClientRect().bottom;
              const sectionBottom = sectionEl.getBoundingClientRect().bottom;
              if (sectionBottom > sidebarBottom) {
                sidebarEl.scrollBy({
                  top: sectionBottom - sidebarBottom + 16,
                  behavior: "smooth",
                });
              }
            }
          }, 250);
        }
      }
    );
  }

  // Maps sub-page paths to the logical parent menu item path so the
  // correct sidebar entry stays highlighted on detail/create/fund pages.
  getActiveMenuPath() {
    const path = this.state.currentMenu;
    // Create contract → Payer
    if (path.startsWith("/escrow/contract/create")) {
      return "/escrow/payer/contracts";
    }
    // Fund contract → Payer
    if (path.startsWith("/escrow/contract/fund/")) {
      return "/escrow/payer/contracts";
    }
    // Contract detail page (/escrow/payer|payee|approval/contract/…) → list
    const detailMatch = path.match(/^\/escrow\/(payer|payee|approval)\/contract\//);
    if (detailMatch) {
      return `/escrow/${detailMatch[1]}/contracts`;
    }
    return path;
  }

  handleSelectCurrentMenu(param) {
    // Save scroll position to sessionStorage so it survives component remount
    // (each page renders its own Sidebar instance, so the old one is destroyed on route change)
    if (this.sidebarRef.current) {
      sessionStorage.setItem(
        "sidebar_scroll_top",
        this.sidebarRef.current.scrollTop
      );
    }
    this.setState({ currentMenu: param });
    // Close sidebar on mobile after clicking a link
    if (window.innerWidth < 992 && this.props.isSidebarOpen) {
      this.props.dispatch({ type: "CLOSE_SIDEBAR" });
    }
  }

  processMenuPermissions(restoreScrollTop) {
    const accountStatusId = localStorage.getItem(
      SITENAMEALIAS + "_account_status_id"
    );
    const topMenus = [...this.state.topMenus];
    const sections = JSON.parse(JSON.stringify(this.state.sections));
    const currentPath = this.props.location.pathname;
    let expandedSection = null;
    let expandedSubSection = null;
    const isVerified = accountStatusId == "6";

    const isTopMenuPath = topMenus.some((item) => item.path === currentPath);

    const isSubMerchant =
      localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0";
    const accessList = isSubMerchant
      ? JSON.parse(localStorage.getItem(SITENAMEALIAS + "_access_list"))
      : null;

    const hasAccessListPermission = (item) => {
      if (!accessList) return false;
      const itemTitle = (item.permissionTitle || "").toLowerCase();
      // Strip leading slash so "/api-key" matches access_list url "api-key"
      const itemPath = (item.path || "").replace(/^\//, "").toLowerCase();
      for (let j = 0; j < accessList.length; j++) {
        const entry = accessList[j];
        if (entry.menu && entry.menu.toLowerCase() === itemTitle) {
          return true;
        }
        // Fallback: match by URL/path so items whose permissionTitle differs
        // from the backend menu name (e.g. "Documentation" vs "API") still resolve.
        if (itemPath && entry.url && entry.url.toLowerCase() === itemPath) {
          return true;
        }
      }
      return false;
    };

    const resolvePermission = (item) => {
      if (item.id === "earn" && this.state.enableMerchantReferral !== 1) {
        item.isRenderable = false;
        return;
      }

      // Hide User Management if in Test Mode
      if (item.title === "User Management" && this.props.isTestMode) {
        item.isRenderable = false;
        return;
      }
      if (
        (item.id === "escrow" ||
          (item.permissionTitle &&
            item.permissionTitle.startsWith("Escrow"))) &&
        this.props.isTestMode
      ) {
        item.isRenderable = false;
        return;
      }

      if (item.title === "API" && this.props.isTestMode) {
        const brokerId =
          Cookies.get("paybito_launch_platform_broker_id") ||
          localStorage.getItem(SITENAMEALIAS + "_broker_id");
        item.path =
          process.env.PUBLIC_URL + `/api-docs-test.html?brokerId=${brokerId}`;
      }

      // Escrow items are always visible regardless of verification or access list
      if (
        item.id === "escrow" ||
        (item.permissionTitle && item.permissionTitle.startsWith("Escrow"))
      ) {
        item.isRenderable = true;
        return;
      }

      if (item.permissionLevel === 1) {
        item.isRenderable = true;
      } else if (isSubMerchant) {
        // Sub-merchants: always restrict to access_list, regardless of verification status
        item.isRenderable = hasAccessListPermission(item);
      } else if (isVerified) {
        item.isRenderable = true;
      } else {
        // Parent merchant, not verified: show all items as visible (locked state handled in render)
        item.isRenderable = true;
      }
    };

    // Process top menus
    for (let i = 0; i < topMenus.length; i++) {
      resolvePermission(topMenus[i]);
    }

    // Process sections
    for (let s = 0; s < sections.length; s++) {
      const section = sections[s];

      if (section.isSingleLink) {
        resolvePermission(section);
        if (
          !isTopMenuPath &&
          section.singlePath === currentPath &&
          !expandedSection
        ) {
          // Don't expand single-link sections
        }
        continue;
      }

      const items = section.items;
      for (let i = 0; i < items.length; i++) {
        resolvePermission(items[i]);

        if (items[i].isSubSection && items[i].children) {
          for (let c = 0; c < items[i].children.length; c++) {
            resolvePermission(items[i].children[c]);

            if (
              !isTopMenuPath &&
              items[i].children[c].path === currentPath &&
              !expandedSection
            ) {
              expandedSection = section.id;
              expandedSubSection = items[i].subSectionId;
            }
          }
          // Sub-section parents (e.g. "Checkout Templates") are UI-only
          // groupings that won't appear in access_list. Show the parent
          // whenever at least one child is renderable.
          if (items[i].children.some((c) => c.isRenderable)) {
            items[i].isRenderable = true;
          }
        }

        if (
          !isTopMenuPath &&
          !items[i].isSubSection &&
          items[i].path === currentPath &&
          !expandedSection
        ) {
          expandedSection = section.id;
        }
      }
    }

    if (!expandedSection && !isTopMenuPath) {
      if (currentPath.startsWith("/escrow/")) {
        expandedSection = "escrow";
      } else {
        expandedSection = "get-paid";
      }
    }

    this.setState(
      {
        topMenus,
        sections,
        expandedSection,
        expandedSubSection,
        accountStatusId,
        isVerified,
      },
      () => {
        // Restore scroll position after the final re-render
        if (restoreScrollTop != null && this.sidebarRef.current) {
          this.sidebarRef.current.scrollTop = restoreScrollTop;
        }
      }
    );
  }

  componentDidMount() {
    // Restore sidebar scroll position saved before the previous instance was destroyed
    const savedScrollTop = sessionStorage.getItem("sidebar_scroll_top");
    if (savedScrollTop != null) {
      this._restoreScrollTop = parseInt(savedScrollTop, 10);
      sessionStorage.removeItem("sidebar_scroll_top");
    }

    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    if (merchantId) {
      FetchUserSettings({ merchant_id: merchantId })
        .then((res) => {
          if (res.data && res.data[0]) {
            this.setState(
              { enableMerchantReferral: res.data[0].enable_merchant_referral },
              () => {
                this.processMenuPermissions(this._restoreScrollTop);
              }
            );
          } else {
            this.processMenuPermissions(this._restoreScrollTop);
          }
        })
        .catch((err) => {
          console.error("Error fetching user settings", err);
          this.processMenuPermissions(this._restoreScrollTop);
        });
    } else {
      this.processMenuPermissions(this._restoreScrollTop);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ currentMenu: this.props.location.pathname });
      this.processMenuPermissions();
    }
  }

  // Check if an item is locked (not verified and requires verification).
  // Sub-merchants are never shown as locked — their access is governed
  // entirely by the parent's access_list, not by verification status.
  isItemLocked(item) {
    const isSubMerchant =
      localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0";
    if (isSubMerchant) return false;
    return !this.state.isVerified && item.permissionLevel === 2;
  }

  renderMenuItem(item, idx, _buttonColor, indentLevel = 0) {
    const paddingLeft = indentLevel === 0 ? 58 : indentLevel === 1 ? 58 : 88;
    const locked = this.isItemLocked(item);
    const tourSlug = (item.title || "")
      .toLowerCase()
      .replace(/[^\w]+/g, "-")
      .replace(/^-|-$/g, "");

    if (item.isExternal) {
      return (
        <li
          className="sidebar-menu-item"
          key={idx}
          data-tour={`submenu-${tourSlug}`}
        >
          <a
            className={`sidebar-nav-link ${locked ? "locked-item" : ""}`}
            href={locked ? undefined : item.path}
            target={locked ? undefined : "_blank"}
            rel={locked ? undefined : "noopener noreferrer"}
            onClick={locked ? (e) => e.preventDefault() : undefined}
            style={{
              paddingLeft: `${paddingLeft}px`,
              cursor: locked ? "not-allowed" : "pointer",
            }}
            title={locked ? this.lockTooltip : undefined}
          >
            <i
              className={`mdi ${item.icon} menu-item-icon`}
              style={{ color: "var(--text-color, #6a6b83)" }}
            ></i>
            <span
              className="menu-item-title"
              style={{ color: "var(--text-color, #141212)" }}
            >
              {item.title}
            </span>
            {!locked && (
              <i
                className="mdi mdi-open-in-new"
                style={{
                  fontSize: "14px",
                  opacity: 0.4,
                  color: "var(--text-color, #6a6b83)",
                }}
              ></i>
            )}
          </a>
        </li>
      );
    }

    return (
      <li
        className="sidebar-menu-item"
        key={idx}
        data-tour={`submenu-${tourSlug}`}
      >
        {locked ? (
          <div
            className="sidebar-nav-link locked-item"
            style={{ paddingLeft: `${paddingLeft}px`, cursor: "not-allowed" }}
            title={this.lockTooltip}
          >
            <i
              className={`mdi ${item.icon} menu-item-icon`}
              style={{ color: "var(--text-color, #6a6b83)" }}
            ></i>
            <span
              className="menu-item-title"
              style={{ color: "var(--text-color, #141212)" }}
            >
              {item.title}
            </span>
          </div>
        ) : (
          <NavLink
            className={`sidebar-nav-link ${
              this.getActiveMenuPath() === item.path ? "active-link" : ""
            }`}
            to={item.path}
            onClick={() => this.handleSelectCurrentMenu(item.path)}
            style={{
              paddingLeft: item.title === "Checkout Templates" ? `100px` : "",
            }}
          >
            <i
              className={`mdi ${item.icon} menu-item-icon`}
              style={{
                color: "var(--text-color, #6a6b83)",
              }}
            ></i>
            <span
              className="menu-item-title"
              style={{
                color: "var(--text-color, #141212)",
              }}
            >
              {item.title}
            </span>
          </NavLink>
        )}
      </li>
    );
  }

  renderSubSection(item, idx, _buttonColor) {
    const isSubExpanded = this.state.expandedSubSection === item.subSectionId;
    const locked = this.isItemLocked(item);
    const hasRenderableChildren = item.children.some((c) => c.isRenderable);
    const tourSlug = (item.title || "")
      .toLowerCase()
      .replace(/[^\w]+/g, "-")
      .replace(/^-|-$/g, "");

    if (!hasRenderableChildren) return null;

    return (
      <li className="sidebar-menu-item" key={idx}>
        <div
          className={`sidebar-nav-link sidebar-subsection-toggle ${
            isSubExpanded ? "subsection-active" : ""
          } ${locked ? "locked-item" : ""}`}
          data-tour={`submenu-${tourSlug}`}
          onClick={(e) => this.toggleSubSection(item.subSectionId, e)}
          style={{ paddingLeft: "58px", cursor: "pointer" }}
          title={locked ? this.lockTooltip : undefined}
        >
          <i
            className={`mdi ${item.icon} menu-item-icon`}
            style={{
              color: "var(--text-color, #6a6b83)",
            }}
          ></i>
          <span
            className="menu-item-title"
            style={{
              color: "var(--text-color, #141212)",
              flex: 1,
            }}
          >
            {item.title}
          </span>
          <i
            className={`mdi mdi-chevron-down subsection-chevron ${
              isSubExpanded ? "expanded" : ""
            }`}
          ></i>
        </div>

        {/* Sub-section children */}
        <div
          className={`subsection-items-wrapper ${
            isSubExpanded ? "expanded" : ""
          }`}
        >
          <ul className="subsection-items">
            <div className="subsection-items-inner">
              {item.children.map(
                (child, cIdx) =>
                  child.isRenderable &&
                  this.renderMenuItem(child, cIdx, null, 2)
              )}
            </div>
          </ul>
        </div>
      </li>
    );
  }

  render() {
    const buttonColor =
      localStorage.getItem(SITENAMEALIAS + "_buttonColour") || "#0052ff";
    // Sub-merchants are never shown as locked — visibility is fully driven by
    // their parent's access_list, so treat them as "verified" for lock UI.
    const isSubMerchant =
      localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0";
    const isVerified = isSubMerchant ? true : this.state.isVerified;

    return (
      <Fragment>
        <style>{`
          /* ── Mobile Sidebar Overlay ── */
          .sidebar-mobile-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s ease, visibility 0.3s ease;
            z-index: 999;
          }
          .sidebar-mobile-overlay.active {
            opacity: 1;
            visibility: visible;
          }

          /* ── Sidebar Layout & Scroll ── */
          .sidebar-offcanvas {
            display: flex !important;
            flex-direction: column !important;
            max-height: calc(100vh - 60px) !important;
            min-height: calc(100vh - 60px) !important;
            position: sticky;
            top: 60px;
            overflow: hidden !important;
          }

          .sidebar-scrollable-content {
            flex: 1;
            overflow-y: auto !important;
            overflow-x: hidden !important;
            scrollbar-width: thin;
            scrollbar-color: transparent transparent;
          }
          .sidebar-scrollable-content:hover { scrollbar-color: rgba(128,128,128,0.18) transparent; }
          .sidebar-scrollable-content::-webkit-scrollbar { width: 3px; }
          .sidebar-scrollable-content::-webkit-scrollbar-track { background: transparent; }
          .sidebar-scrollable-content::-webkit-scrollbar-thumb { background: transparent; border-radius: 99px; }
          .sidebar-scrollable-content:hover::-webkit-scrollbar-thumb { background: rgba(128,128,128,0.18); }

          /* ── Mobile Responsive ── */
          @media (max-width: 991.98px) {
            .sidebar {
              display: none !important;
            }
            .sidebar.mobile-open {
              display: flex !important;
            }
            .sidebar-offcanvas {
              position: fixed !important;
              top: 60px;
              left: 0;
              bottom: 0;
              width: 260px;
              max-height: calc(100vh - 60px);
              height: calc(100vh - 60px) !important;
              min-height: calc(100vh - 60px) !important;
              transform: translateX(-100%);
              transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              z-index: 1050;
              box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
            }
            .sidebar-offcanvas.mobile-open {
              transform: translateX(0);
            }
          }

          /* ── Section dividers ── */
          .sidebar-section,
          .sidebar-single-link-section {
            border-bottom: 1px solid var(--body-color-less2, rgba(128,128,128,0.1));
          }
          .sidebar-section:last-child { border-bottom: none; }

          /* ── Section header ── */
          .section-header {
            display: flex;
            align-items: center;
            padding: 10px 16px;
            cursor: pointer;
            user-select: none;
            gap: 12px;
            transition: background 0.15s;
            border-radius: 0;
          }
          .section-header:hover { background: rgba(128,128,128,0.05); }

          .section-header-icon {
            width: 34px;
            height: 34px;
            border-radius: 9px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            flex-shrink: 0;
            transition: background 0.2s, color 0.2s;
          }

          .section-header-icon-active i {
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .section-header-title {
            flex: 1;
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 0.1px;
            color: var(--text-color, #141212);
            opacity: 0.85;
            line-height: 1;
          }

          .section-chevron {
            font-size: 18px;
            color: var(--text-color, #6a6b83);
            opacity: 0.35;
            transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1),
                        opacity 0.15s;
            flex-shrink: 0;
          }
          .section-chevron.expanded {
            transform: rotate(180deg);
            opacity: 0.6;
          }

          /* ── Accordion — grid trick (no max-height jump) ── */
          .section-items-wrapper {
            display: grid;
            grid-template-rows: 0fr;
            transition: grid-template-rows 0.26s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .section-items-wrapper.expanded {
            grid-template-rows: 1fr;
          }
          .section-items {
            overflow: hidden;
            min-height: 0;
            list-style: none;
            margin: 0;
            padding: 0;
          }
          .section-items-inner {
            padding: 4px 0 10px;
          }

          /* ── Sub-section accordion ── */
          .subsection-items-wrapper {
            display: grid;
            grid-template-rows: 0fr;
            transition: grid-template-rows 0.22s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .subsection-items-wrapper.expanded {
            grid-template-rows: 1fr;
          }
          .subsection-items {
            overflow: hidden;
            min-height: 0;
            list-style: none;
            margin: 0;
            padding: 0;
          }
          .subsection-items-inner {
            padding: 2px 0 6px;
          }

          .subsection-chevron {
            font-size: 15px;
            color: var(--text-color, #6a6b83);
            opacity: 0.35;
            margin-left: auto;
            transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1),
                        opacity 0.15s;
            flex-shrink: 0;
          }
          .subsection-chevron.expanded {
            transform: rotate(180deg);
            opacity: 0.6;
          }

          /* ── Menu items ── */
          .sidebar-menu-item { list-style: none; }

          .sidebar-menu-item .sidebar-nav-link {
            display: flex;
            align-items: center;
            padding: 7px 16px 7px 58px;
            text-decoration: none;
            position: relative;
            gap: 10px;
            transition: background 0.15s;
            border-radius: 0;
          }
          .sidebar-menu-item .sidebar-nav-link:hover {
            background: rgba(128,128,128,0.05);
          }
          .sidebar-menu-item .sidebar-nav-link.active-link {
            background: linear-gradient(135deg, rgba(99,102,241,0.08) 0%, rgba(139,92,246,0.08) 100%);
          }
          .sidebar-menu-item .sidebar-nav-link.active-link::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 52%;
            border-radius: 0 3px 3px 0;
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
          }

          .menu-item-icon {
            font-size: 17px;
            width: 20px;
            text-align: center;
            flex-shrink: 0;
            opacity: 0.45;
            transition: opacity 0.15s, color 0.15s;
          }
          .sidebar-menu-item .sidebar-nav-link.active-link .menu-item-icon {
            opacity: 1;
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .sidebar-menu-item .sidebar-nav-link:hover .menu-item-icon { opacity: 0.75; }

          .menu-item-title {
            font-size: 13px;
            font-weight: 500;
            color: var(--text-color, #141212);
            opacity: 0.65;
            transition: opacity 0.15s, color 0.15s;
          }
          .sidebar-menu-item .sidebar-nav-link.active-link .menu-item-title {
            opacity: 1;
            font-weight: 600;
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .sidebar-menu-item .sidebar-nav-link:hover .menu-item-title { opacity: 0.85; }

          /* subsection indent */
          .subsection-items .sidebar-menu-item .sidebar-nav-link {
            padding-left: 70px;
          }
          .subsection-items .menu-item-icon { font-size: 15px; }
          .subsection-items .menu-item-title { font-size: 12.5px; }

          /* ── Top menu ── */
          .sidebar-top-menu {
            padding: 6px 0;
            border-bottom: 1px solid var(--body-color-less2, rgba(128,128,128,0.1));
          }
          .sidebar-top-item { list-style: none; }

          .sidebar-top-item .sidebar-top-link {
            display: flex;
            align-items: center;
            padding: 10px 16px;
            text-decoration: none;
            position: relative;
            gap: 12px;
            transition: background 0.15s;
          }
          .sidebar-top-item .sidebar-top-link:hover { background: rgba(128,128,128,0.05); }
          .sidebar-top-item .sidebar-top-link.active-link { background: linear-gradient(135deg, rgba(99,102,241,0.08) 0%, rgba(139,92,246,0.08) 100%); }
          .sidebar-top-item .sidebar-top-link.active-link::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 52%;
            border-radius: 0 3px 3px 0;
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
          }
          .sidebar-top-item .sidebar-top-link.active-link .top-item-icon {
            background: linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.12) 100%) !important;
            color: rgb(99,102,241) !important;
          }
          .sidebar-top-item .sidebar-top-link.active-link .top-item-icon i {
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .sidebar-top-item .sidebar-top-link.active-link .top-item-title {
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .sidebar-top-item .top-item-icon {
            width: 34px;
            height: 34px;
            border-radius: 9px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            flex-shrink: 0;
            transition: background 0.2s, color 0.2s;
          }
          .sidebar-top-item .top-item-title {
            flex: 1;
            font-size: 13px;
            font-weight: 600;
            color: var(--text-color, #141212);
            transition: color 0.15s;
          }

          /* ── Single-link section ── */
          .sidebar-single-link {
            display: flex;
            align-items: center;
            padding: 10px 16px;
            text-decoration: none;
            position: relative;
            gap: 12px;
            transition: background 0.15s;
          }
          .sidebar-single-link:hover { background: rgba(128,128,128,0.05); }
          .sidebar-single-link.active-link { background: linear-gradient(135deg, rgba(99,102,241,0.08) 0%, rgba(139,92,246,0.08) 100%); }
          .sidebar-single-link.active-link::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 52%;
            border-radius: 0 3px 3px 0;
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
          }
          .sidebar-single-link.active-link .section-header-icon {
            background: linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.12) 100%) !important;
          }
          .sidebar-single-link.active-link .section-header-icon i {
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .sidebar-single-link.active-link .section-header-title {
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          /* ── Subsection toggle row ── */
          .sidebar-subsection-toggle { user-select: none; }
          .sidebar-subsection-toggle:hover { background: rgba(128,128,128,0.05); }
          .sidebar-subsection-toggle.subsection-active .menu-item-icon {
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%) !important;
            -webkit-background-clip: text !important;
            -webkit-text-fill-color: transparent !important;
            background-clip: text !important;
          }
          .sidebar-subsection-toggle.subsection-active .menu-item-title {
            background: linear-gradient(135deg, rgb(99,102,241) 0%, rgb(139,92,246) 100%) !important;
            -webkit-background-clip: text !important;
            -webkit-text-fill-color: transparent !important;
            background-clip: text !important;
          }

          /* ── Locked state ── */
          .locked-section .section-header-icon,
          .locked-section .section-header-title,
          .locked-top-item .top-item-icon,
          .locked-top-item .top-item-title,
          .locked-single-link .section-header-icon,
          .locked-single-link .section-header-title { opacity: 0.35; }
          .locked-item .menu-item-icon,
          .locked-item .menu-item-title { opacity: 0.3; }

          .sidebar-lock-icon {
            font-size: 12px;
            flex-shrink: 0;
            opacity: 0.45;
          }

          /* ── Locked tooltip ── */
          [data-locked-tooltip] { position: relative; }
          [data-locked-tooltip]::after {
            content: attr(data-locked-tooltip);
            position: absolute;
            left: 100%;
            top: 50%;
            transform: translateY(-50%);
            margin-left: 8px;
            background: #1a1a2e;
            color: #fff;
            font-size: 11px;
            font-weight: 500;
            padding: 7px 11px;
            border-radius: 7px;
            white-space: nowrap;
            pointer-events: none;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.15s, visibility 0.15s;
            z-index: 9999;
            box-shadow: 0 4px 14px rgba(0,0,0,0.2);
            line-height: 1.4;
          }
          [data-locked-tooltip]:hover::after { opacity: 1; visibility: visible; }
        `}</style>

        {/* Mobile Overlay */}
        {this.props.isSidebarOpen && (
          <div
            className="sidebar-mobile-overlay active"
            onClick={() => {
              this.props.dispatch({ type: "CLOSE_SIDEBAR" });
            }}
          ></div>
        )}

        <nav
          className={`sidebar sidebar-offcanvas ${
            this.props.isSidebarOpen ? "mobile-open" : ""
          }`}
          id="sidebar"
          ref={this.sidebarRef}
          style={{ background: "var(--body-color)" }}
        >
          <div className="sidebar-scrollable-content" style={{ padding: "8px 0 16px 0" }}>
            {/* Standalone Top Menu Items */}
            <div className="sidebar-top-menu">
              {this.state.topMenus.map((item, idx) => {
                if (!item.isRenderable) return null;

                const isGetStarted = item.permissionLevel === 1;
                const locked = !isGetStarted && !isVerified;

                return (
                  <div
                    className={`sidebar-top-item ${
                      locked ? "locked-top-item" : ""
                    }`}
                    key={idx}
                    {...(item.path === "/get-started"
                      ? { "data-tour": "getting-started" }
                      : item.path === "/dashboard"
                      ? { "data-tour": "dashboard-overview" }
                      : {})}
                    {...(locked
                      ? { "data-locked-tooltip": this.lockTooltip }
                      : {})}
                  >
                    {locked ? (
                      <div
                        className="sidebar-top-link"
                        style={{ cursor: "not-allowed" }}
                        title={this.lockTooltip}
                      >
                        <div
                          className="top-item-icon"
                          style={{
                            background:
                              "var(--body-color-less, rgba(0,0,0,0.04))",
                            color: "var(--text-color, #6a6b83)",
                          }}
                        >
                          <i className={`mdi ${item.icon}`}></i>
                        </div>
                        <span
                          className="top-item-title"
                          style={{ color: "var(--text-color, #141212)" }}
                        >
                          {item.title}
                        </span>
                        <span className="sidebar-lock-icon">🔒</span>
                      </div>
                    ) : (
                      <NavLink
                        className={`sidebar-top-link ${
                          this.state.currentMenu === item.path
                            ? "active-link"
                            : ""
                        }`}
                        to={item.path}
                        onClick={() => {
                          this.handleSelectCurrentMenu(item.path);
                        }}
                      >
                        <div
                          className="top-item-icon"
                          style={{
                            background:
                              this.state.currentMenu === item.path
                                ? "linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.12) 100%)"
                                : "var(--body-color-less, rgba(0,0,0,0.04))",
                            color:
                              this.state.currentMenu === item.path
                                ? "rgb(99,102,241)"
                                : "var(--text-color, #6a6b83)",
                          }}
                        >
                          <i className={`mdi ${item.icon}`}></i>
                        </div>
                        <span
                          className="top-item-title"
                          style={{
                            color:
                              this.state.currentMenu === item.path
                                ? "rgb(99,102,241)"
                                : "var(--text-color, #141212)",
                          }}
                        >
                          {item.title}
                        </span>
                      </NavLink>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Sections */}
            {this.state.sections.map((section) => {
              const locked = !isVerified && section.permissionLevel !== 1;

              // Handle single-link sections (e.g., Transactions)
              if (section.isSingleLink) {
                if (!section.isRenderable) return null;

                return (
                  <div
                    className={`sidebar-single-link-section ${
                      locked ? "locked-single-link" : ""
                    }`}
                    key={section.id}
                    data-tour={`menu-${section.id}`}
                    {...(locked
                      ? { "data-locked-tooltip": this.lockTooltip }
                      : {})}
                  >
                    {locked ? (
                      <div
                        className="sidebar-single-link"
                        style={{ cursor: "not-allowed" }}
                        title={this.lockTooltip}
                      >
                        <div
                          className="section-header-icon"
                          style={{
                            background:
                              "var(--body-color-less, rgba(0,0,0,0.04))",
                            color: "var(--text-color, #6a6b83)",
                          }}
                        >
                          <i className={`mdi ${section.icon}`}></i>
                        </div>
                        <span
                          className="section-header-title"
                          style={{ color: "var(--text-color, #141212)" }}
                        >
                          {section.title}
                        </span>
                        <span className="sidebar-lock-icon">🔒</span>
                      </div>
                    ) : (
                      <NavLink
                        className={`sidebar-single-link ${
                          this.state.currentMenu === section.singlePath
                            ? "active-link"
                            : ""
                        }`}
                        to={section.singlePath}
                        onClick={() =>
                          this.handleSelectCurrentMenu(section.singlePath)
                        }
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          className="section-header-icon"
                          style={{
                            background:
                              this.state.currentMenu === section.singlePath
                                ? "linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.12) 100%)"
                                : "var(--body-color-less, rgba(0,0,0,0.04))",
                            color:
                              this.state.currentMenu === section.singlePath
                                ? "rgb(99,102,241)"
                                : "var(--text-color, #6a6b83)",
                          }}
                        >
                          <i className={`mdi ${section.icon}`}></i>
                        </div>
                        <span
                          className="section-header-title"
                          style={{
                            color:
                              this.state.currentMenu === section.singlePath
                                ? "rgb(99,102,241)"
                                : "var(--text-color, #141212)",
                          }}
                        >
                          {section.title}
                        </span>
                      </NavLink>
                    )}
                  </div>
                );
              }

              // Regular accordion sections
              const isExpanded = this.state.expandedSection === section.id;
              const hasRenderableItems = section.items.some((item) => {
                if (item.isSubSection && item.children) {
                  return item.children.some((c) => c.isRenderable);
                }
                return item.isRenderable;
              });

              if (!hasRenderableItems) return null;

              return (
                <div
                  className={`sidebar-section ${
                    locked ? "locked-section" : ""
                  }`}
                  key={section.id}
                  ref={(el) => (this.sectionRefs[section.id] = el)}
                  data-tour={`menu-${section.id}`}
                  {...(locked
                    ? { "data-locked-tooltip": this.lockTooltip }
                    : {})}
                >
                  {/* Section Header */}
                  <div
                    className="section-header"
                    onClick={() => this.toggleSection(section.id)}
                    title={locked ? this.lockTooltip : undefined}
                  >
                    <div
                      className={`section-header-icon ${
                        isExpanded ? "section-header-icon-active" : ""
                      }`}
                      style={{
                        background: isExpanded
                          ? "linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.12) 100%)"
                          : "var(--body-color-less, rgba(0,0,0,0.04))",
                        color: isExpanded
                          ? "rgb(99,102,241)"
                          : "var(--text-color, #6a6b83)",
                      }}
                    >
                      <i className={`mdi ${section.icon}`}></i>
                    </div>
                    <span className="section-header-title">
                      {section.title}
                    </span>
                    <i
                      className={`mdi mdi-chevron-down section-chevron ${
                        isExpanded ? "expanded" : ""
                      }`}
                    ></i>
                    {locked && <span className="sidebar-lock-icon">🔒</span>}
                  </div>

                  {/* Accordion Content */}
                  <div
                    className={`section-items-wrapper ${
                      isExpanded ? "expanded" : ""
                    }`}
                  >
                    <ul className="section-items">
                      <div className="section-items-inner">
                        {section.items.map((item, idx) => {
                          if (item.isSubSection && item.children) {
                            if (!item.isRenderable) return null;
                            return this.renderSubSection(
                              item,
                              idx,
                              buttonColor
                            );
                          }

                          if (!item.isRenderable) return null;
                          return this.renderMenuItem(item, idx, buttonColor);
                        })}
                      </div>
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
          {getAuthToken() && (
            <div
              className="sidebar-bottom-toggle"
              style={{
                padding: "16px 24px",
                borderTop: "1px solid var(--body-color-less2, rgba(128, 128, 128, 0.15))",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "var(--body-color)",
                flexShrink: 0,
              }}
            >
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "var(--text-color, #141212)",
                  opacity: 0.85,
                }}
              >
                {this.props.isTestMode ? "Test Mode" : "Live Mode"}
              </span>
              <div
                onClick={this.handleToggleMode}
                style={{
                  width: "38px",
                  height: "20px",
                  background: this.props.isTestMode
                    ? "#f59e0b"
                    : "rgba(128,128,128,0.2)",
                  borderRadius: "10px",
                  position: "relative",
                  cursor: this.state.modeLoading ? "not-allowed" : "pointer",
                  transition: "all 0.3s ease",
                  border: "1px solid rgba(255,255,255,0.1)",
                  opacity: this.state.modeLoading ? 0.6 : 1,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "14px",
                    height: "14px",
                    background: "#fff",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "2px",
                    left: this.props.isTestMode ? "20px" : "2px",
                    transition:
                      "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {this.state.modeLoading && (
                    <i
                      className="mdi mdi-loading mdi-spin"
                      style={{
                        fontSize: "8px",
                        color: this.props.isTestMode ? "#f59e0b" : "#8e7e7e",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </nav>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isSidebarOpen: state.isSidebarOpen,
  isTestMode: state.isTestMode,
});

export default connect(mapStateToProps)(withRouter(Sidebar));
